@if (!isRestrictedToSinglePage()) {
  <nav class="pageheader__nav" [class.pageheader__nav--open]="isToggled">

    <div class="mobile-top-menu mobile-only">
      <div class="left-side">
        <a class="pageheader__navlink" routerLink="/newsletter/form">{{'fspro.front.header.user_feature.label.newsletter' | translate}}</a>
      </div>
      @if (user && user.canCreateSubscription) {
        <div class="right-side">
          <a routerLink="/subscribe" class="pageheader__navlink">
            <div class="upgrade-button">
              <span>{{ (this.user?.shouldUpdate === 'renew' ? 'fspro.front.renew_action' : 'fspro.front.upgrade_action') | translate }}</span>
            </div>
          </a>
        </div>
      } @else if (!user) {
        <div class="right-side">
          <a routerLink="/sign-up">
            <div class="join-button">
              <span>{{ 'fspro.front.header.nav.label.join' | translate }}</span>
            </div>
          </a>
        </div>
      }

    </div>

    <div class="rh-button-container mobile-only">
      @if (isUserRH() && !isRestrictedToSinglePage()) {
        <button class="rh-button" (click)="toggleRhMenu()" type="button" [ngClass]="{'reverse-button-color': rhMenuDisplayed }">
          {{ (rhMenuDisplayed? 'fspro.front.close_rights_holders_menu': 'fspro.front.open_rights_holders_menu')| translate }}
        </button>
      }
    </div>
    <div class="link-container">
      <ul class="pageheader__navlist" #menuContainer>
        @for (item of items; track item.title) {
          <ng-container *ngTemplateOutlet="defaultTpl; context: { $implicit: item }"></ng-container>
        }
      </ul>
      <div class="rh-menu-container" #rhMenuContainer>
        @if (isUserRH() && !isRestrictedToSinglePage()) {
          <fspro-navbar-rh class="full-space"></fspro-navbar-rh>
        }
      </div>
    </div>
    <ul class="mobile-social-bottom-menu mobile-only">
      <li class="social-link" >
        <a href="https://fr-fr.facebook.com/FestivalScope/" target="_blank">
            <img src="assets/images/facebook-logo-white.svg" alt="facebook">
        </a>
      </li>
      <li class="social-link">
        <a href="https://bsky.app/profile/festivalscope.bsky.social" target="_blank">
            <img src="assets/images/bluesky-icon-white.svg" alt="Bluesky">
        </a>
      </li>
      <li class="social-link">
        <a href="https://www.instagram.com/festival.scope/" target="_blank">
            <img src="assets/images/instagram-logo-white.svg" alt="instagram">
        </a>
      </li>
    </ul>
  </nav>
}

<ng-template let-item #defaultTpl>
  @if (!item.with || item.with()) {
    <li
      class="pageheader__navitem {{'pageheader__navitem--' + item.name }}"
      [ngClass]="'pageheader__navitem--' + item.name + (isItemActive(item) ? '--selected' : '')"
    >
      <a [routerLink]="item.route" class="pageheader__navlink" (click)="dismiss()">
        {{ item.title | translate }}
      </a>
      <div class="link-underline" [ngClass]="'link-underline--' + item.name"></div>
    </li>
  }
</ng-template>
